import script from "./AppSidebar2.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSidebar2.vue?vue&type=script&setup=true&lang=ts"

import "./AppSidebar2.vue?vue&type=style&index=0&id=57e07627&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e07627"]])

export default __exports__